interface SwitchProps {
  name: string;
  size?: "small" | "smallMedium" | "medium" | "mediumLarge" | "large";
  checked: boolean;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
}

const Switch: React.FC<SwitchProps> = ({
  name,
  size = "large",
  checked,
  onChange,
  disabled = false,
}) => {
  const onChangeInner = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };
  return (
    <label
      className={`Switch ${getSwitchSize(size)} ${disabled ? "Disabled" : ""}`}
    >
      <input
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChangeInner}
        disabled={disabled}
      />
      <span className="SwitchThumb Rounded" />
    </label>
  );
};

const getSwitchSize = (size: SwitchProps["size"]) => {
  switch (size) {
    case "small":
      return "SmallSwitch";
    case "smallMedium":
      return "SmallMediumSwitch";
    case "medium":
      return "MediumSwitch";
    case "mediumLarge":
      return "MediumLargeSwitch";
    case "large":
    default:
      return "";
  }
};

export default Switch;
